import { Button } from "antd"
import { useNavigate } from "react-router"
const CancelButton = () => {
    const navigate = useNavigate()
    return <Button onClick={() => navigate('/wplywy')}>Wyjdź</Button>
}
export default CancelButton